export var ImageRenderMode;
(function (ImageRenderMode) {
    ImageRenderMode["Server"] = "server";
    ImageRenderMode["NativeLazyLoad"] = "nativeLazyLoad";
    ImageRenderMode["IntersectionObserver"] = "intersectionObserver";
    ImageRenderMode["Fallback"] = "fallback";
})(ImageRenderMode || (ImageRenderMode = {}));
